import * as React from 'react';
import { useCheckoutSid, useCheckoutUsps } from '@/scopes/checkout/domain/hooks';
import { Benefits } from '@sunwebgroup/ui-components/uds';

export function CheckoutBenefits() {
  const sid = useCheckoutSid();

  if (!sid) {
    return null;
  }

  return (
    <>
      <CheckoutUspsVerticalItem componentId="16b4f482-a986-466b-8100-f0d2aa91e542" /> {/*ACPT NL SUMMER DEFAULT*/}
      <CheckoutUspsVerticalItem componentId="2a6aed99-7d0a-4769-83f4-d10de71131de" /> {/*ACPT NL SUMMER VARIANT*/}
      <CheckoutUspsVerticalItem componentId="1fe05d5d-9d41-4435-bd68-d7c8d27e18f7" /> {/*PROD NL SUMMER DEFAULT*/}
      <CheckoutUspsVerticalItem componentId="e35d55e2-a2ba-41a7-be87-170f01a86d2b" /> {/*PROD NL SUMMER VARIANT*/}
    </>
  );
}

export function CheckoutUspsVerticalItem(props: { componentId: string }) {
  const { componentId } = props;
  const { data, isLoading } = useCheckoutUsps(componentId);

  if (isLoading) return '';
  if (!data) return '';

  return (
    <Benefits.Root $type="vertical">
      {data?.usps.map((item, idx) => <Benefits.Item key={idx} title={item.text} supportingtext={item.subtitle} />)}
    </Benefits.Root>
  );
}
